export default function VideoEmbed({ url }) {
  if (!url) return null;

  // YouTube
  const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/);
  if (ytMatch) {
    const embedUrl = `https://www.youtube.com/embed/${ytMatch[1]}?rel=0&modestbranding=1`;
    return (
      <div data-testid="video-embed" className="video-responsive rounded-none overflow-hidden border border-white/5">
        <iframe
          src={embedUrl}
          title="Project Teaser"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  // Vimeo
  const vimeoMatch = url.match(/(?:vimeo\.com\/)(\d+)/);
  if (vimeoMatch) {
    const embedUrl = `https://player.vimeo.com/video/${vimeoMatch[1]}?title=0&byline=0&portrait=0`;
    return (
      <div data-testid="video-embed" className="video-responsive rounded-none overflow-hidden border border-white/5">
        <iframe
          src={embedUrl}
          title="Project Teaser"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  // Direct video file (mp4, webm, etc.)
  const videoExts = /\.(mp4|webm|mov|avi|mkv)(\?|$)/i;
  if (videoExts.test(url) || url.includes("/api/uploads/")) {
    return (
      <div data-testid="video-embed" className="rounded-none overflow-hidden border border-white/5">
        <video
          src={url}
          controls
          playsInline
          preload="metadata"
          className="w-full aspect-video bg-black"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  // Fallback: try iframe
  return (
    <div data-testid="video-embed" className="video-responsive rounded-none overflow-hidden border border-white/5">
      <iframe
        src={url}
        title="Project Teaser"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
